import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setAuthentication } from "../store/Reducers";
import { useNavigate } from "react-router-dom";
import './Loginpage.css';
import "bootstrap/dist/css/bootstrap.min.css";
import Container from 'react-bootstrap/Container';
import { Row, Col } from "react-bootstrap";
import { Box } from '@mui/material';
import logo from '../assets/companyLogo.png';
import loginBanner from '../assets/loginBanner.jpg';
import { setLoading } from "../store/CommonSlice";
import { CustomMessage } from "../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { login } from "../api/Services/commonServices";
import MailIcon from "@mui/icons-material/Mail";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
 
const Login: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
        CustomMessage("Enter the details", "warning", enqueueSnackbar)
        return;
    }
    dispatch(setLoading(true));
    try {
      const response = await login({email: email, password: password});
      const {data,status} = response;
      if(status.code === 200){
        const dataResponse = {
          isAuthenticated: true,
          role: data.roles,
          name: data.name,
          token: data.token,
          email: data.email,
          userId: data.userId,
          projectIds: data.projectIds
        };
        dispatch(setAuthentication(dataResponse));
        console.log(dataResponse);

        
        navigate("/erp/pages/assetInventory");
      }else{
        CustomMessage(status.message,'error',enqueueSnackbar);
        dispatch(setAuthentication({
          isAuthenticated: false,
          role: [],
          token: "",
          name: "",
          email: "",
          userId: 0,
          projectIds: []
        }));
      }  
    } catch (error: any) {
      CustomMessage(error.message,'error',enqueueSnackbar);
    } finally{
      dispatch(setLoading(false));
    }
  };



  return (
    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center">
      <Container fluid className="px-0">
        <Row className="g-0">
          <Col className="col-12 col-md-6 px-5 d-flex align-items-center justify-content-center">
            <div className="col-lg-8">
              <div className="d-flex justify-content-center pb-0 menard-text">
                {/* <span className="d-none d-lg-block">MENARD</span> */}
                <Box component="a" href="/">
                  <Box component="img" src={logo} alt="Company Logo" sx={{ height: 60, width: 'auto' }} />
                </Box>
              </div>
              <div className="card mb-0 shadow-none border-0">
                <div className="card-body">
                  {/* <div className="pb-2">
                    <h5 className="card-title text-center pb-0 fs-4 mt-0">
                      Login to Your Account
                    </h5>
                    <p className="text-center small">
                      Enter your email & password to login
                    </p>
                  </div> */}

                  <form className="row g-2 needs-validation login-form" onSubmit={handleLogin}>
                    {/* Email Input */}
                    <div className="col-12">
                      {/* <label htmlFor="yourUsername" className="form-label">Email</label> */}
                      <div className="input-group position-relative mb-0">
                        <input
                          type="email"
                          name="username"
                          className="form-control input-with-icon bg-[#F3F1F0]"
                          id="yourUsername"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          placeholder="Enter your email"
                        />
                        <span
                          className=" position-absolute"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer", right: "10px", top: "50%", transform: "translateY(-50%)" }}
                        >
                          <MailIcon />
                        </span>
                      </div>
                    </div>

                    {/* Password Input */}
                    <div className="col-12">
                      {/* <label htmlFor="yourPassword" className="form-label">Password</label> */}
                      <div className="input-group position-relative mb-0">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="form-control input-with-icon"
                          id="yourPassword"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          placeholder="Enter your password"
                        />
                        <span
                          className=" position-absolute"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer", right: "10px", top: "50%", transform: "translateY(-50%)" }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </span>
                      </div>
                    </div>
                    {/* Login Button */}
                    <div className="col-12">
                      <button  className="btn btn-primary w-100 h-45">
                        Log In
                      </button>
                    </div>
                  </form>
                  <div className="pt-3">
                    <ul className="p-0 mt-4">
                      <li className="list-unstyled mb-1">
                        <a href="forgot-password" className="small text-center text-decoration-none">
                          <LockResetOutlinedIcon className="me-1"/> Forgot password?
                        </a>
                      </li>
                      <li className="list-unstyled mb-1">
                        <a href="/register" className="small text-center text-decoration-none">
                          <InfoOutlinedIcon className="me-1"/> About
                        </a>
                      </li>
                      <li className="list-unstyled mb-1">
                        <a href="/register" className="small text-center text-decoration-none">
                          <PrivacyTipOutlinedIcon className="me-1"/> Privacy
                        </a>
                      </li>
                      <li className="list-unstyled">
                        <a href="/register" className="small text-center text-decoration-none">
                          <LanguageOutlinedIcon className="me-1"/> English
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="col-12 col-md-6">
            <img src={loginBanner} className="w-100 vh-100 object-fit-cover login-banner" alt="Menard Logo" />
          </Col>
        </Row>
      </Container>
      {/* <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
            
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default Login;
